import { render, staticRenderFns } from "./header-with-tip.vue?vue&type=template&id=214ed621&"
import script from "./header-with-tip.vue?vue&type=script&lang=js&"
export * from "./header-with-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports